const sceneImage = "/images/scene-05.png";

function Scene05({ onNext }) {
  return (
    <>
      {/* Background */}
      <img
        src={sceneImage}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* Header */}
      <div className="absolute inset-x-4 top-7 z-10 text-center">
        <h1 className="font-playful text-[1.6rem] font-bold leading-none text-white drop-shadow-[0_4px_4px_rgba(0,0,0,0.45)]">
          Tingkatkan skill untuk membuka hadiah lainnya
        </h1>

        {/* <div className="mx-auto mt-3 w-fit rounded-2xl border-2 border-[#8a5a32] bg-[#f5d49a] px-6 py-2 shadow-[0_4px_0_#8a5a32]">
          <p className="font-playful text-2xl font-bold text-[#4b3024]">
            LEVEL 24 ✨
          </p>
        </div> */}
      </div>

      {/* Bottom Content */}
      <div className="absolute inset-x-1 bottom-0 z-10 pb-[calc(0.75rem+env(safe-area-inset-bottom))] text-center">
        <button
          onClick={onNext}
          className="rounded-full border-2 border-[#9a5b08] bg-[#ffd447] px-5 py-2.5 font-playful text-sm font-bold text-[#3d2b1f] shadow-[0_4px_0_#9a5b08] transition-all duration-100 hover:bg-[#ffe071] active:translate-y-[3px] active:shadow-[0_1px_0_#9a5b08]"
        >
          AMBIL HADIAHMU
        </button>
      </div>
    </>
  );
}

export default Scene05;
